const FilterPill = ({ label, selectedValues, onClick, onRemove }) => {
  const count = selectedValues.length;
  const firstOption = selectedValues[0];

  if (count === 0) return null;

  return (
    <div
      onClick={onClick}
      className="inline-flex items-center h-7 rounded-md text-[11px] font-medium bg-blue-50 border border-blue-200 text-blue-700 pl-2.5 pr-1 gap-1 cursor-pointer hover:bg-blue-100 transition-colors duration-150 flex-shrink-0 whitespace-nowrap select-none"
    >
      <span className="text-blue-400 font-normal">{label}</span>
      {count > 1 ? (
        <span className="font-semibold">{count}</span>
      ) : (
        <span className="flex items-center gap-1">
          {firstOption?.icon && (
            <span className="inline-flex size-4 rounded-full overflow-hidden flex-shrink-0 -ml-0.5">
              {firstOption.icon}
            </span>
          )}
          <span className="font-semibold">{firstOption?.label}</span>
        </span>
      )}
      <button
        type="button"
        className="flex items-center justify-center size-4 rounded hover:bg-blue-200 flex-shrink-0 ml-0.5"
        onClick={(e) => { e.stopPropagation(); onRemove(); }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="size-3">
          <path d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
        </svg>
      </button>
    </div>
  );
};

export default FilterPill;
